var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "my-quiz-card",
      on: {
        click: function($event) {
          return _vm.$emit("click", $event)
        }
      }
    },
    [
      _vm.isQuizTags
        ? _c(
            "div",
            { staticClass: "tag-wrapper" },
            _vm._l(_vm.getQuizTags(_vm.quiz), function(value, index) {
              return _c("div", { key: index, staticClass: "tag" }, [
                _vm._v("\n      " + _vm._s(value) + "\n    ")
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.quiz.content || "-"))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "quiz-type" }, [
        _vm._v(_vm._s(_vm.getQuizTypeName))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "date" }, [
        _vm._v("최초 생성일 " + _vm._s(_vm.getQuizCreatedDate))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "divider" }),
      _vm._v(" "),
      _c("div", { staticClass: "row stats-wrapper" }, [
        _c("div", { staticClass: "col-3" }, [
          _c("div", { staticClass: "label" }, [_vm._v("정답수")]),
          _vm._v(" "),
          _c("div", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.getToCommas(_vm.getCorrectResultsCount)))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-6" }, [
          _c("div", { staticClass: "label" }, [_vm._v("총 문제 푼수")]),
          _vm._v(" "),
          _c("div", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.getToCommas(_vm.getTotalResultsCount)))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-3 quiz-state-wrapper" }, [
          _c(
            "div",
            {
              staticClass: "quiz-state",
              class: _vm.getQuizState(_vm.getQuizSet).value
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.getQuizState(_vm.getQuizSet).label) +
                  "\n      "
              )
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4dc23358", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4dc23358","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/my-quizzes/components/MyQuizCard.vue
// module id = pRPP
// module chunks = 1